var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transaction-info-container"},[_vm._v(" Transaction: "),_c('a',{attrs:{"href":("https://etherscan.io/tx/" + _vm.transactionHash),"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.cTrimmedTransactionHash)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }